// extracted by mini-css-extract-plugin
module.exports = {"radio":"dd31006766--radio--dnKhF","label":"dd31006766--label--qbIHK","indicator":"dd31006766--indicator--Y3uK8","hasLabel":"dd31006766--hasLabel--LVjFn"};